import type { UpdateUserPreferencesClients, WebClientPreference } from '@ms/yammer-graphql';

type UserPreferencesNormalizer = (response: { readonly data: UpdateUserPreferencesClients }) => WebClientPreference;

export const normalizeUserPreferences: UserPreferencesNormalizer = ({ data: { updateUserPreferences } }) => {
  if (!updateUserPreferences) {
    return 'LEGACY';
  }

  return updateUserPreferences.userPreferences.webClientPreference;
};
